/* SW49 — mini sepet şeridi: tıkla → çekmece; sepet değişince kendini yeniler */
(function () {
  'use strict';
  var wrap = document.getElementById('shopify-section-sw-mini-cart');

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sw-minicart]');
    if (!btn) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open(btn);
    else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  });

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!wrap) return;
      fetch(window.location.pathname + '?sections=sw-mini-cart', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['sw-mini-cart'];
          if (typeof html !== 'string') return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('#shopify-section-sw-mini-cart') || tmp;
          wrap.innerHTML = inner.innerHTML;
        })
        .catch(function () {});
    }, 300);
  }

  if (wrap && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }

  // ---- Sepet önerileri: ok tuşları + fare tekerleğiyle yatay kaydırma ----
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-sw-upsell-prev]');
    var next = e.target.closest('[data-sw-upsell-next]');
    if (!prev && !next) return;
    var list = (prev || next).closest('.sw-cart-upsell').querySelector('[data-sw-upsell-list]');
    if (list) list.scrollBy({ left: (next ? 1 : -1) * list.clientWidth * 0.8, behavior: 'smooth' });
  });
  document.addEventListener('wheel', function (e) {
    var list = e.target.closest('[data-sw-upsell-list]');
    if (!list || Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
    if (list.scrollWidth <= list.clientWidth) return;
    e.preventDefault();
    list.scrollLeft += e.deltaY;
  }, { passive: false });
})();
